import { SubscriptionScheduleSelectionComponent } from 'src/app/component/subscription-schedule-selection/subscription-schedule-selection.component';
import { SubscriptionStopSelectionComponent } from 'src/app/component/subscription-stop-selection/subscription-stop-selection.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { EventService } from 'src/app/services/event.service';
import { LoadingService } from 'src/app/services/loading.service';

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService, SuscriptionService } from '@core/services';
import { ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-selection-summary',
  templateUrl: './selection-summary.page.html',
  styleUrls: ['./selection-summary.page.scss'],
})
export class SelectionSummaryPage {
  subscriptionPrice: number;
  lockedZone = {
    go: null,
    return: null,
  };
  lockedRoute = {
    go: null,
    return: null,
  };
  subscription;
  validForm = false;
  mySubscription;
  extraSubscription: boolean;
  isResetSubscription: boolean;

  constructor(
    private modalCtrl: ModalController,
    private eventService: EventService,
    private navCtrl: NavController,
    private apiService: ApiService,
    private authService: AuthService,
    private storage: StorageService,
    private dataService: DataService,
    private router: Router,
    private loadingService: LoadingService,
    private suscriptionService: SuscriptionService
  ) {}

  ionViewDidEnter() {
    this.resetSubscription();
    const subscription = this.dataService.getData('subscription');
    if (subscription) {
      this.mySubscription = subscription;
      this.setSubscriptionFullName();
    } else {
      this.getSuscription();
    }
    this.checkIfIsExtraSubscription();
    this.checkIfIsResetSubscription();
    this.validateForm();
  }

  checkIfIsResetSubscription() {
    this.isResetSubscription = this.suscriptionService.isResetSuscribable();
    this.mySubscription.reset_subscribable = this.isResetSubscription;
  }

  checkIfIsExtraSubscription() {
    if (this.mySubscription && this.suscriptionService.isExtraRegistrationOpen()) {
      this.extraSubscription = true;
      this.mySubscription.extra_subscribable = true;
      this.subscription.forEach((daySubscription) => {
        daySubscription.go.extra = 1;
        daySubscription.return.extra = 1;
      });
    }
  }

  resetClicked() {
    this.resetSubscription();
    this.checkIfIsExtraSubscription();
  }

  resetSubscription() {
    this.subscriptionPrice = undefined;
    this.subscription = [
      {
        day: 'Lunes',
        dotw: 1,
        go: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
        return: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
      },
      {
        day: 'Martes',
        dotw: 2,
        go: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
        return: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
      },
      {
        day: 'Miércoles',
        dotw: 3,
        go: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
        return: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
      },
      {
        day: 'Jueves',
        dotw: 4,
        go: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
        return: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
      },
      {
        day: 'Viernes',
        dotw: 5,
        go: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
        return: {
          trip_id: null,
          stop: null,
          departure_time: null,
          bus_id: null,
          extra: 0,
        },
      },
    ];
    this.lockedZone = {
      go: null,
      return: null,
    };
    this.lockedRoute = {
      go: null,
      return: null,
    };
  }

  getSuscription() {
    this.authService.get('suscription').then((res) => {
      this.mySubscription = res.data;
      this.storage.set('subscription', this.mySubscription);
      if (this.mySubscription.name === 'PV' || this.mySubscription.status === 1) {
        this.eventService.publish('transportec:subscribed');
        this.navCtrl.navigateRoot(['/tecservice-transportec/transportec']);
      }
      this.setSubscriptionFullName();
      if (res.data.extra) {
        for (let index = 0; index < this.subscription.length; index++) {
          this.subscription[index].go.extra = 1;
          this.subscription[index].return.extra = 1;
          if (index === this.subscription.length - 1) {
            console.log(this.subscription);
          }
        }
      }
    });
  }

  setSubscriptionFullName() {
    switch (this.mySubscription.name) {
      case 'PV':
        this.mySubscription.fullname = 'Pago por viaje';
        break;
      case 'SR':
        this.mySubscription.fullname = 'Redondo Fijo';
        break;
      case 'SRF':
        this.mySubscription.fullname = 'Redondo Flexible';
        break;
      case 'SS':
        this.mySubscription.fullname = 'Sencillo Fijo';
        break;
      case 'SSF':
        this.mySubscription.fullname = 'Sencillo Flexible';
        break;
    }
  }

  validateForm() {
    if (this.mySubscription && this.mySubscription.type === 'complete') {
      for (const element of this.subscription) {
        if (!element.go.stop || !element.go.departure_time || !element.return.stop || !element.return.departure_time) {
          this.validForm = false;
          break;
        } else {
          this.validForm = true;
        }
      }
    } else if (this.mySubscription && this.mySubscription.type === 'go') {
      for (const element of this.subscription) {
        if (!element.go.stop || !element.go.departure_time) {
          this.validForm = false;
          break;
        } else {
          this.validForm = true;
        }
      }
    } else if (this.mySubscription && this.mySubscription.type === 'return') {
      for (const element of this.subscription) {
        if (!element.return.stop || !element.return.departure_time) {
          this.validForm = false;
          break;
        } else {
          this.validForm = true;
        }
      }
    } else {
      this.validForm = false;
    }
  }

  selectStop(item, direction = 'go') {
    this.modalCtrl
      .create({
        component: SubscriptionStopSelectionComponent,
        componentProps: {
          day: item.day,
          dotw: item.dotw,
          s: item,
          amount: 0,
          type: direction,
          lockedZone: this.lockedZone[direction],
          lockedRoute: this.lockedRoute[direction],
        },
      })
      .then((modal) => {
        modal.present();
        modal.onDidDismiss().then((res) => {
          if (res.data && res.data.stop) {
            if (direction === 'go') {
              item.go.stop = res.data.stop;
            } else {
              item.return.stop = res.data.stop;
            }
            this.blockZoneAndRoute(direction, res.data.stop.route);
            this.validateForm();
            this.selectSchedule(item, direction);
          }
        });
      });
  }

  blockZoneAndRoute(direction, route) {
    if (!this.lockedZone[direction] && this.mySubscription.name.toLowerCase().indexOf('f') === -1) {
      this.lockedZone[direction] = route.zone_id;
      this.lockedRoute[direction] = route.id;
    }
  }

  selectSchedule(item, direction = 'go') {
    const s = direction === 'go' ? item.go.stop : item.return.stop;
    this.modalCtrl
      .create({
        component: SubscriptionScheduleSelectionComponent,
        componentProps: {
          day: item.day,
          dotw: item.dotw,
          stop: s,
          amount: 0,
          type: direction,
        },
      })
      .then((modal) => {
        modal.present();
        modal.onDidDismiss().then((res) => {
          if (res.data && res.data.schedule) {
            if (direction === 'go') {
              item.go.departure_time = res.data.schedule.starts_at;
              item.go.bus_id = res.data.schedule.bus_id;
              item.go.trip_id = res.data.schedule.id;
            } else {
              item.return.departure_time = res.data.schedule.starts_at;
              item.return.bus_id = res.data.schedule.bus_id;
              item.return.trip_id = res.data.schedule.id;
            }
            /*
            if(!this.subscriptionPrice || this.subscriptionPrice < res.data.radialPrice) {
              this.subscriptionPrice = res.data.radialPrice
            }
            */
            this.checkPrice();
          }
          this.validateForm();
        });
      });
  }

  next() {
    this.loadingService.present();
    setTimeout(() => {
      this.loadingService.dismiss();
      this.eventService.publish('transportec:subscribed');
      this.navCtrl.navigateRoot(['/tecservice-transportec/transportec']);
    }, 1000);
  }

  checkPrice() {
    if (this.suscriptionService.isExtraRegistrationOpen() || this.suscriptionService.isResetSuscribable()) {
      return;
    }
    const subscription = {
      subscription: this.mySubscription,
      schedule: this.subscription,
    };
    this.apiService.postData('suscription-radial-amount', subscription).then((res) => {
      this.subscriptionPrice = res.amount;
    });
  }

  goPayment() {
    const subscription = {
      subscription: this.mySubscription,
      schedule: this.subscription,
      price: this.subscriptionPrice,
    };
    this.dataService.setData('subscription-radial', subscription);
    this.router.navigate(['/tecservice-transportec/transportec/subscribe/payment-method']);
  }

  save() {
    this.loadingService.present();
    this.apiService
      .postData('suscriptions_dailies', { subscriptions: this.subscription })
      .then((res) => {
        if (res.success) {
          this.getSuscription();
        } else {
          this.authService.presentToast('Ocurrió un error favor de intentarlo más tarde.');
        }
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }
}
